import { useEffect, useState } from "react";
import "./accommodation.css";

const UL_WIDGET_SCRIPT_ID = "ul-widget-snippet";
const UL_WIDGET_SCRIPT_SRC = "https://d3h5kc2fo9op52.cloudfront.net/widget.js";
const AMBER_ACCOMMODATION_URL = "https://accommodation.niecindonesia.com";

const Accommodation = () => {
  const [selectedProvider, setSelectedProvider] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("provider") === "uni-living" ? "uni-living" : "";
  });
  const widgetId = process.env.REACT_APP_UL_WIDGET_ID || "YOUR_WIDGET_ID";
  const city = process.env.REACT_APP_UL_WIDGET_CITY || "london";

  useEffect(() => {
    if (selectedProvider !== "uni-living") {
      return;
    }

    if (document.getElementById(UL_WIDGET_SCRIPT_ID)) {
      return;
    }

    const script = document.createElement("script");
    script.id = UL_WIDGET_SCRIPT_ID;
    script.src = UL_WIDGET_SCRIPT_SRC;
    script.async = true;
    document.body.appendChild(script);
  }, [selectedProvider]);

  return (
    <>
      <main className="ul-accommodation-page">
        <section className="ul-accommodation-hero">
          <div className="container">
            <span className="ul-accommodation-label">Student Accommodation</span>
            <h1>Choose your accommodation platform</h1>
          </div>
        </section>

        <section className="ul-accommodation-options-section">
          <div className="container">
            <div className="ul-accommodation-options">
              <article className="ul-accommodation-option">
                <div>
                  <h2>Amber</h2>
                  <p>
                    Continue to the current Amber accommodation page used by NIEC
                    students.
                  </p>
                </div>
                <a
                  className="ul-accommodation-button"
                  href={AMBER_ACCOMMODATION_URL}
                  target="_blank"
                  rel="noreferrer"
                >
                  Open Amber
                </a>
              </article>

              <article className="ul-accommodation-option">
                <div>
                  <h2>University Living</h2>
                  <p>
                    Find your perfect student accommodation, close to university & close to life.
                  </p>
                </div>
                <button
                  className="ul-accommodation-button"
                  type="button"
                  onClick={() => setSelectedProvider("uni-living")}
                >
                  Open Uni-Living
                </button>
              </article>
            </div>
          </div>
        </section>

        {selectedProvider === "uni-living" && (
          <section className="ul-accommodation-widget-section">
            <div className="container">
              <div className="ul-accommodation-widget-header">
                <h2>Uni-Living accommodation search</h2>
                <button
                  className="ul-accommodation-secondary-button"
                  type="button"
                  onClick={() => setSelectedProvider("")}
                >
                  Back to options
                </button>
              </div>
              <div
                id="root-ul"
                data-widgetid={"69ce57d6670133b7580ced99"}
                data-city={"london"}
                data-primarycolor="#111"
                data-fontcolor="#333"
                data-iconcolor="#111"
              />
            </div>
          </section>
        )}
        {!selectedProvider && (
          <section className="ul-accommodation-empty-section">
            <div className="container">
              <p>Select Uni-Living to load the accommodation search here.</p>
            </div>
          </section>
        )}
      </main>
      <script src="https://d3hk5c2fo9op52.cloudfront.net/widget.js"></script>
    </>

  );
};

export default Accommodation;
